import React from "react";

import { P_Props } from "./PageWithSubRoute.type";
import SubRouteMenu from "./SubRouteMenu";

const PageWithSubRoutePresenter: React.FC<P_Props> = (props) => {
  return (
    <div className="page-with-subroute">
      <SubRouteMenu routeMenu={props.routeMenu} />
      {props.children}
    </div>
  );
};

export default PageWithSubRoutePresenter;
